import { takeLeading, select } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { isNull, get } from 'lodash';
import {
  REQUEST_LAWYER_REJECTED_CLAIMS,
  REQUEST_SEARCH_REJECTED_CLAIMS,
} from 'containers/RejectedClaimsPage/constants';
import {
  setRejectedClaims,
  setSearchRejectedClaims,
} from 'containers/RejectedClaimsPage/actions';
import userToken from 'containers/services/security/access-token-storage';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

export function* requestRejectedClaims(action: {
  status: string;
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { status, page, pageSize } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/common/claims?status=${status}&page=${page}&pageSize=${pageSize}&isIntervenant=true`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setRejectedClaims);
}

export function* requestLawyerRejectedClaimsSaga() {
  yield takeLeading(REQUEST_LAWYER_REJECTED_CLAIMS, requestRejectedClaims);
}
export function* requestSearchRejectedClaims(action: any) {
  const { token, searchQuery } = action;
  const tokenApi = token ? token : get(userToken.get(), 'token');
  const path = token
    ? `/corporeal/common/search?isIntervenant=true`
    : `/corporeal/common/search`;
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${tokenApi}`,
    },
    body: JSON.stringify(searchQuery),
  };
  yield callApi(path, {}, options, [], setSearchRejectedClaims);
}

export function* requestSearchRejectedClaimsSaga() {
  yield takeLeading(
    REQUEST_SEARCH_REJECTED_CLAIMS,
    requestSearchRejectedClaims,
  );
}

export default [
  requestLawyerRejectedClaimsSaga,
  requestSearchRejectedClaimsSaga,
];
